import { PrivateSettings } from '@wix/wix-vod-api-site-based/privateSettings';
import { keysToSnakeCase } from '@wix/wix-vod-shared/common';
import { parseSuccessResponse } from './parsers/success-response';
import { toError } from '../../parsers/to-error';
export class PrivateSettingsService {
    constructor(httpClient, baseUrl) {
        this.httpClient = httpClient;
        this.get = () => this.privateSettingsService
            .getSettings()
            .then(parseSuccessResponse)
            .catch(toError);
        this.update = (settings) => this.privateSettingsService
            .update(keysToSnakeCase(settings))
            .then(parseSuccessResponse)
            .catch(toError);
        this.reset = () => this.privateSettingsService
            .reset()
            .then((response) => response.data)
            .catch(toError);
        this.privateSettingsService = new PrivateSettings(httpClient, baseUrl);
    }
}
//# sourceMappingURL=settings.js.map